module.exports = __webpack_public_path__ + "img/img45.430b2283.svg";